"use client"

import { Button } from '../../../shared/components/ui/button'
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '../../../shared/components/ui/dialog'
import { SlidersHorizontal } from 'lucide-react'
import React, { useState, memo } from 'react'
import HomeOwnerFilterForm from './forms/home-owner-filter-form'
import { useIsMobile } from '../../../shared/hooks/use-mobile'

const HomeOwnersFilterButton = memo(function HomeOwnersFilterButton() {
    const [isOpen, setIsOpen] = useState(false)
    const isMobile = useIsMobile()
    
    const handleOpenChange = (open: boolean) => {
        setIsOpen(open)
    }
    
    return (
        <Dialog open={isOpen} onOpenChange={handleOpenChange}>
            <DialogTrigger asChild>
                <Button 
                    variant={"default"} 
                    size={"sm"} 
                    className='shrink-0 bg-primary hover:bg-primary/90 text-white font-bold rounded-md gap-2 py-1 h-10'
                >
                    <SlidersHorizontal />
                    {!isMobile && <span>Filter</span>}
                </Button>
            </DialogTrigger>
            <DialogContent
                className="max-h-[90vh] max-w-6xl"
                onInteractOutside={(e) => {
                    const target = e.target as HTMLElement
                    if (target?.closest?.('[data-avoid-dialog-close], [data-radix-popper-content-wrapper]')) {
                        e.preventDefault()
                    }
                }}
                onFocusOutside={(e) => {
                    const target = e.target as HTMLElement
                    if (target?.closest?.('[data-avoid-dialog-close], [data-radix-popper-content-wrapper]')) {
                        e.preventDefault()
                    }
                }}
            >
                <DialogTitle>Filter Homeowner Details</DialogTitle>
                <div className="overflow-y-auto max-h-[calc(90vh-120px)] pr-4">
                    {isOpen && (
                        <HomeOwnerFilterForm onSuccessCallback={() => setIsOpen(false)} />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
})

export default HomeOwnersFilterButton
